import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import heroCelebration from "@/assets/hero-celebration.png";

const Hero = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <section className="relative overflow-hidden bg-background">
      <div className="container mx-auto px-4 py-24 md:py-36 relative z-10">
        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="flex-1 text-center md:text-start"
          >
            <span className="inline-block text-xs font-light text-muted-foreground mb-6 tracking-[0.3em] uppercase">
              {t("hero.badge")}
            </span>
            <h1 className="text-4xl md:text-6xl font-extralight text-foreground leading-[1.15] tracking-tight">
              {t("hero.title")}{" "}
              <span className="italic">{t("hero.titleItalic")}</span>{" "}
              {t("hero.titleEnd")}
            </h1>
            <p className="mt-8 text-base font-light text-muted-foreground max-w-md leading-relaxed mx-auto md:mx-0">
              {t("hero.description")}
            </p>
            <div className="mt-12 flex flex-wrap gap-4 justify-center md:justify-start">
              <Button
                size="lg"
                className="bg-primary text-primary-foreground hover:bg-primary/85 rounded-full px-10 text-sm font-light tracking-wide gap-2 shadow-none"
                onClick={() => navigate("/create")}
              >
                {t("hero.cta")}
                <ArrowRight size={16} strokeWidth={1.5} />
              </Button>
              <Button
                size="lg"
                variant="secondary"
                className="rounded-full px-10 text-sm font-light tracking-wide shadow-none"
                onClick={() => document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' })}
              >
                {t("hero.secondary")}
              </Button>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.9, ease: "easeOut", delay: 0.2 }}
            className="flex-1 flex justify-center"
          >
            <img
              src={heroCelebration}
              alt="People celebrating together with gifts and cake"
              className="w-full max-w-md md:max-w-lg object-contain"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
